import DesignerView from './DesignerView';

export default DesignerView;
